import Board from '../components/Board';

export default function kanbanBoard() {
  return (
      <Board />
  )
}